import React, { Component } from "react";
import { Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { verificarEmail } from "../../crud/auth.crud";
import { toAbsoluteUrl } from "../../../_metronic";

class ConfirmarEmail extends Component {
	state = {
		loading: true,
		success: false,
		message: "",
	};

	componentDidMount() {
		const params = new URLSearchParams(window.location.search);
		const token = params.get("token");

		if (!token) {
			this.setState({ loading: false, success: false, message: "Token de verificação não encontrado." });
			return;
		}

		verificarEmail(token)
			.then((res) => {
				this.setState({ loading: false, success: true, message: res.data.message });
			})
			.catch(({ response }) => {
				this.setState({ loading: false, success: false, message: response?.data?.message || "Não foi possível confirmar seu e-mail." });
			});
	}

	render() {
		const { loading, success, message } = this.state;

		return (
			<div className="container" style={{ maxWidth: 500, marginTop: '80px' }}>
				<div className="text-center mb-4">
					<img alt="Logo" src={toAbsoluteUrl("/images/logo-color.png")} style={{ maxWidth: '180px' }} />
				</div>
				<Card className="my-3">
					<CardHeader>
						<h3>{loading ? "Confirmando seu e-mail..." : (success ? "E-mail confirmado!" : "Não foi possível confirmar")}</h3>
					</CardHeader>
					<CardBody className="text-center">
						{loading ? (
							<Spinner />
						) : (
							<>
								<p>{message}</p>
								<a className="btn btn-primary" href="/">Voltar para o início</a>
							</>
						)}
					</CardBody>
				</Card>
			</div>
		);
	}
}

export default ConfirmarEmail;
